<template>
  <div class="box company-detail">
    <div class="box-header">
      <h3 class="box-title">Benefits</h3>
      <p>W:1280 x H:320</p>
    </div>
    <div class="item" v-for="(infos, indx) in benefits" :key="indx">
      <input type="text" class="input" v-model="benefits[indx].details" placeholder="Benefit Name" />
      <i class="fa-solid fa-trash" @click="benefits.splice(indx, 1)"></i>
    </div>
    <button class="button primary" @click="addBenefits()">Add</button>
  </div>
</template>

<script>
export default {
  props: ["isBenefit"],
  data() {
    return {
      benefits: []
    }
  },
  watch: {
    benefits: {
      handler(value) {
        this.$emit("input", value)
      },
      immediate: true,
      deep: true
    },
    isBenefit() {
      this.benefits = this.isBenefit
    }
  },
  methods: {
    addBenefits() {
      this.benefits.push({
        details: ""
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;

  i {
    cursor: pointer;
    top: 0;
    right: 0;
    width: 30px;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(var(--alert-color-rgb), 0.1);
    color: var(--alert-color);
  }

  input {
    border-radius: 0 !important;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
</style>
